import React, {Component} from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import {
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Input,
    InputGroup,
    InputGroupAddon,
    FormGroup,
    Label,
} from 'reactstrap';
import axios from 'axios';
import {API_ROOT} from '../../api-config';
import Swal from 'sweetalert2';
import moment from 'moment';
import 'moment-timezone';
import SingleDatePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import {getVehicles} from '../Vehicles/VehicleFunctions';

moment.tz.setDefault("America/Halifax");

const newLineItem = () => ({
    category1_id: null,
    category2_id: null,
    category3_id: null,
    categories2: [],
    categories3: [],
    loading_cat2: false,
    loading_cat3: false,
    loading_items: false,
    item_code: "",
    name: "",
    item_description: "",
    rate: "",
    quantity: 1,
    amount: "",
    item_suggestions: [],
    show_suggestions: false,
    suggestion_pos: null,
    item_locked: false,
});

class CreateMaintenanceTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ticket_type: "",
            equipment_type: "",
            unit_id: "",
            odometer: "",
            vendor_id: "",
            date_completed: null,
            invoice_num: "",
            description: "",
            vehicles: [],
            vendors: [],
            categories1: [],
            line_items: [newLineItem()],
            processing: false,
            loading: true,
        };
    }

    componentDidMount() {
        document.title = "New Maintenance Ticket";
        const self = this;
        axios.defaults.withCredentials = true;

        getVehicles(function (data) {
            const arr = Array.isArray(data) ? data : Object.values(data);
            arr.sort((a, b) => (a.name < b.name ? -1 : 1));
            self.setState({vehicles: arr});
        });

        Promise.all([
            axios.get(API_ROOT + '/maintenance/vendors'),
            axios.get(API_ROOT + '/maintenance/categories/1'),
        ]).then(([vendorsRes, cats1Res]) => {
            self.setState({
                vendors: vendorsRes.data,
                categories1: cats1Res.data,
                loading: false,
            });
        }).catch(() => self.setState({loading: false}));
    }

    updateField = (name, value) => {
        if (value && value.target) value = value.target.value;
        this.setState({[name]: value});
    };

    updateCompletedDate = (event, picker) => {
        if (event.type === "apply") {
            this.setState({date_completed: moment(picker.startDate)});
        }
    };

    updateLineItem = (idx, updates) => {
        const items = [...this.state.line_items];
        const updated = {...items[idx], ...updates};
        if ('rate' in updates || 'quantity' in updates) {
            const rate = parseFloat(updated.rate);
            const qty = parseFloat(updated.quantity);
            updated.amount = (!isNaN(rate) && !isNaN(qty)) ? (rate * qty).toFixed(2) : "";
        }
        items[idx] = updated;
        this.setState({line_items: items});
    };

    setCategory1 = (idx, cat) => {
        const items = [...this.state.line_items];
        items[idx] = {
            ...items[idx],
            category1_id: cat.category1_id,
            category2_id: null,
            category3_id: null,
            categories2: [],
            categories3: [],
            item_suggestions: [],
            loading_cat2: !!cat.category1_id,
            loading_cat3: false,
            loading_items: false,
        };
        this.setState({line_items: items});
        if (!cat.category1_id) return;
        axios.get(API_ROOT + '/maintenance/categories/2?category1_id=' + cat.category1_id)
            .then(r => {
                const updated = [...this.state.line_items];
                updated[idx] = {...updated[idx], categories2: r.data, loading_cat2: false};
                this.setState({line_items: updated});
            }).catch(() => {
            const updated = [...this.state.line_items];
            updated[idx] = {...updated[idx], loading_cat2: false};
            this.setState({line_items: updated});
        });
    };

    setCategory2 = (idx, cat) => {
        const items = [...this.state.line_items];
        items[idx] = {
            ...items[idx],
            category2_id: cat.category2_id,
            category3_id: null,
            categories3: [],
            item_suggestions: [],
            loading_cat3: true,
            loading_items: false,
        };
        this.setState({line_items: items});
        axios.get(API_ROOT + '/maintenance/categories/3?category2_id=' + cat.category2_id)
            .then(r => {
                const updated = [...this.state.line_items];
                updated[idx] = {...updated[idx], categories3: r.data, loading_cat3: false};
                this.setState({line_items: updated});
            }).catch(() => {
            const updated = [...this.state.line_items];
            updated[idx] = {...updated[idx], loading_cat3: false};
            this.setState({line_items: updated});
        });
    };

    setCategory3 = (idx, cat) => {
        const items = [...this.state.line_items];
        items[idx] = {...items[idx], category3_id: cat.category3_id};
        this.setState({line_items: items}, () => this.loadItemSuggestions(idx));
    };

    loadItemSuggestions = (idx) => {
        const {vendor_id} = this.state;
        const item = this.state.line_items[idx];
        if (!vendor_id || !item.category3_id) return;
        const preload = [...this.state.line_items];
        preload[idx] = {...preload[idx], loading_items: true, item_suggestions: []};
        this.setState({line_items: preload});
        axios.get(`${API_ROOT}/maintenance/items?vendor_id=${vendor_id}&category3_id=${item.category3_id}`)
            .then(r => {
                const updated = [...this.state.line_items];
                updated[idx] = {...updated[idx], item_suggestions: r.data, loading_items: false};
                this.setState({line_items: updated});
            }).catch(() => {
            const updated = [...this.state.line_items];
            updated[idx] = {...updated[idx], loading_items: false};
            this.setState({line_items: updated});
        });
    };

    selectSuggestion = (idx, suggestion) => {
        const items = [...this.state.line_items];
        const rate = parseFloat(suggestion.price) || 0;
        const qty = parseFloat(items[idx].quantity) || 1;
        items[idx] = {
            ...items[idx],
            item_code: suggestion.item,
            name: suggestion.name,
            item_description: suggestion.description,
            rate: suggestion.price,
            amount: (rate * qty).toFixed(2),
            item_locked: true,
            show_suggestions: false,
        };
        this.setState({line_items: items});
    };

    clearItemLock = (idx) => {
        this.updateLineItem(idx, {
            item_code: "",
            name: "",
            item_description: "",
            rate: "",
            amount: "",
            item_locked: false,
        });
    };

    addLineItem = () => {
        this.setState(prev => ({line_items: [...prev.line_items, newLineItem()]}));
    };

    removeLineItem = (idx) => {
        const items = [...this.state.line_items];
        items.splice(idx, 1);
        this.setState({line_items: items.length > 0 ? items : [newLineItem()]});
    };

    getFilteredSuggestions = (idx) => {
        const item = this.state.line_items[idx];
        const q = (item.item_code || "").toLowerCase();
        if (!q) return item.item_suggestions;
        return item.item_suggestions.filter(s =>
            (s.item || "").toLowerCase().includes(q) || (s.name || "").toLowerCase().includes(q)
        );
    };

    saveTicket = () => {
        this.setState({processing: true});
        const self = this;
        axios.defaults.withCredentials = true;
        axios.post(API_ROOT + '/maintenance/ticket', {
            ticket_type: this.state.ticket_type,
            equipment_type: this.state.equipment_type,
            unit_id: this.state.unit_id,
            odometer: this.state.odometer,
            vendor_id: this.state.vendor_id,
            date_completed: this.state.date_completed,
            invoice_num: this.state.invoice_num,
            description: this.state.description,
            line_items: this.state.line_items.map(({categories2, categories3, item_suggestions, show_suggestions, ...item}) => item),
        })
            .then(r => {
                Swal("Success!", r.data.Message || "Ticket saved.", "success");
                self.setState({processing: false});
            })
            .catch(err => {
                if (err.response && err.response.status === 401) {
                    self.props.userSignOut();
                } else {
                    Swal("Error", (err.response && err.response.data && err.response.data.Message) || "An error occurred.", "error");
                    self.setState({processing: false});
                }
            });
    };

    render() {
        const {
            ticket_type, equipment_type, unit_id, odometer,
            vendor_id, date_completed, invoice_num, description,
            vehicles, vendors, categories1, line_items, processing,
        } = this.state;

        const headerComplete = !!(ticket_type && equipment_type && unit_id && vendor_id);

        return (
            <ContentWrapper>
                <div className="content-heading">
                    <div>New Maintenance Ticket</div>
                    <div className="ml-auto">
                        <Button color="primary" onClick={this.saveTicket} disabled={processing}>
                            <i className={(processing ? "fa fa-spinner fa-spin mr-2" : "d-none")}></i>
                            Save Ticket
                        </Button>
                    </div>
                </div>

                <Card>
                    <CardBody>
                        <Row>
                            <Col md={6}>
                                <FormGroup row className="mb-2">
                                    <Label sm={4} className={"font-weight-bold"}>Ticket Type: <span className="text-danger">*</span></Label>
                                    <Col sm={8}>
                                        <Input type="select" bsSize="sm" value={ticket_type} onChange={e => this.updateField('ticket_type', e.target.value)}>
                                            <option value="">(select)</option>
                                            <option>Scheduled</option>
                                            <option>Emergency</option>
                                        </Input>
                                    </Col>
                                </FormGroup>
                                <FormGroup row className="mb-2">
                                    <Label sm={4} className={"font-weight-bold"}>Equipment: <span className="text-danger">*</span></Label>
                                    <Col sm={8}>
                                        <Input type="select" bsSize="sm" value={equipment_type} onChange={e => this.updateField('equipment_type', e.target.value)}>
                                            <option value="">(select)</option>
                                            <option>Chassis</option>
                                            <option>Trailer</option>
                                            <option>Truck</option>
                                        </Input>
                                    </Col>
                                </FormGroup>
                                <FormGroup row className="mb-2">
                                    <Label sm={4} className={"font-weight-bold"}>Unit: <span className="text-danger">*</span></Label>
                                    <Col sm={8}>
                                        <Input type="select" bsSize="sm" value={unit_id} onChange={e => this.updateField('unit_id', e.target.value)}>
                                            <option value="">(select)</option>
                                            {vehicles.map(v => {
                                                const id = v.vehicle_id != null ? v.vehicle_id : v.equipment_id;
                                                return <option key={id} value={id}>{v.name}</option>;
                                            })}
                                        </Input>
                                    </Col>
                                </FormGroup>
                                <FormGroup row className="mb-2">
                                    <Label sm={4} className={"font-weight-bold"}>Odometer:</Label>
                                    <Col sm={8}>
                                        <Input type="number" bsSize="sm" value={odometer} onChange={e => this.updateField('odometer', e.target.value)} placeholder="0"/>
                                    </Col>
                                </FormGroup>
                                <FormGroup row className="mb-2">
                                    <Label sm={4} className={"font-weight-bold"}>Vendor: <span className="text-danger">*</span></Label>
                                    <Col sm={8}>
                                        <Input type="select" bsSize="sm" value={vendor_id} onChange={e => {
                                            const vid = e.target.value;
                                            this.setState({vendor_id: vid}, () => {
                                                this.state.line_items.forEach((item, i) => {
                                                    if (item.category3_id) this.loadItemSuggestions(i);
                                                });
                                            });
                                        }}>
                                            <option value="">(select)</option>
                                            {vendors.map(v => (
                                                <option key={v.vendor_id} value={v.vendor_id}>{v.name}</option>
                                            ))}
                                        </Input>
                                    </Col>
                                </FormGroup>
                                <FormGroup row className="mb-2">
                                    <Label sm={4} className={"font-weight-bold"}>Date Completed:</Label>
                                    <Col sm={8}>
                                        <SingleDatePicker
                                            onEvent={this.updateCompletedDate}
                                            date={(date_completed == null ? moment() : date_completed)}
                                            singleDatePicker={true}
                                            autoUpdateInput={true}
                                        >
                                            <div className="btn btn-light btn-sm">
                                                {date_completed == null ? '(select)' : date_completed.format('MMM. D, YYYY')}
                                            </div>
                                        </SingleDatePicker>
                                    </Col>
                                </FormGroup>
                                <FormGroup row className="mb-0">
                                    <Label sm={4} className={"font-weight-bold"}>Invoice #:</Label>
                                    <Col sm={8}>
                                        <Input type="text" bsSize="sm" value={invoice_num} onChange={e => this.updateField('invoice_num', e.target.value)}/>
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col md={6} className="d-flex flex-column">
                                <Label className={"font-weight-bold"}>Description:</Label>
                                <Input
                                    type="textarea"
                                    value={description}
                                    onChange={e => this.updateField('description', e.target.value)}
                                    style={{flex: 1, minHeight: "230px", resize: "none"}}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                <Card className="mt-3">
                    <CardBody>
                        <div style={{position: "relative"}}>
                            {!headerComplete && (
                                <div style={{
                                    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                                    background: "rgba(248,249,250,0.92)",
                                    zIndex: 10,
                                    display: "flex", flexDirection: "column",
                                    alignItems: "center", justifyContent: "center",
                                    borderRadius: "4px", border: "2px dashed #dee2e6",
                                    minHeight: "80px",
                                }}>
                                    <i className="fas fa-lock fa-2x text-muted mb-2"></i>
                                    <div className="font-weight-bold text-muted">Complete the ticket details above to add items</div>
                                    <div className="small text-muted mt-1">Ticket Type, Equipment, Unit, and Vendor are required</div>
                                </div>
                            )}
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-2">
                                <thead className="thead-light">
                                <tr>
                                    <th style={{minWidth: "130px"}}>Category</th>
                                    <th style={{minWidth: "130px"}}>Category 2</th>
                                    <th style={{minWidth: "130px"}}>Category 3</th>
                                    <th style={{minWidth: "160px"}}>Item</th>
                                    <th style={{minWidth: "160px"}}>Name</th>
                                    <th style={{minWidth: "200px"}}>Description</th>
                                    <th style={{minWidth: "110px"}}>Rate</th>
                                    <th style={{minWidth: "75px"}}>Qty</th>
                                    <th style={{minWidth: "110px"}}>Amount</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {line_items.map((item, idx) => {
                                    const suggestions = this.getFilteredSuggestions(idx);
                                    return (
                                        <tr key={idx}>
                                            <td>
                                                <Input type="select" bsSize="sm" value={item.category1_id || ""} onChange={e => {
                                                    const cat = categories1.find(c => String(c.category1_id) === e.target.value);
                                                    if (cat) this.setCategory1(idx, cat);
                                                    else this.setCategory1(idx, {category1_id: null});
                                                }}>
                                                    <option value="">(select)</option>
                                                    {categories1.map(c => (
                                                        <option key={c.category1_id} value={c.category1_id}>{c.name}</option>
                                                    ))}
                                                </Input>
                                            </td>
                                            <td>
                                                {item.loading_cat2 ? (
                                                    <Input type="select" bsSize="sm" disabled>
                                                        <option>(loading...)</option>
                                                    </Input>
                                                ) : (
                                                    <Input type="select" bsSize="sm" value={item.category2_id || ""} disabled={!item.category1_id} onChange={e => {
                                                        const cat = item.categories2.find(c => String(c.category2_id) === e.target.value);
                                                        if (cat) this.setCategory2(idx, cat);
                                                    }}>
                                                        <option value="">(select)</option>
                                                        {item.categories2.map(c => (
                                                            <option key={c.category2_id} value={c.category2_id}>{c.name}</option>
                                                        ))}
                                                    </Input>
                                                )}
                                            </td>
                                            <td>
                                                {item.loading_cat3 ? (
                                                    <Input type="select" bsSize="sm" disabled>
                                                        <option>(loading...)</option>
                                                    </Input>
                                                ) : (
                                                    <Input type="select" bsSize="sm" value={item.category3_id || ""} disabled={!item.category2_id} onChange={e => {
                                                        const cat = item.categories3.find(c => String(c.category3_id) === e.target.value);
                                                        if (cat) this.setCategory3(idx, cat);
                                                    }}>
                                                        <option value="">(select)</option>
                                                        {item.categories3.map(c => (
                                                            <option key={c.category3_id} value={c.category3_id}>{c.name}</option>
                                                        ))}
                                                    </Input>
                                                )}
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div style={{flex: 1}}>
                                                        <Input
                                                            type="text"
                                                            bsSize="sm"
                                                            value={item.item_code}
                                                            disabled={item.item_locked}
                                                            onChange={e => {
                                                                const rect = e.target.getBoundingClientRect();
                                                                this.updateLineItem(idx, {
                                                                    item_code: e.target.value,
                                                                    show_suggestions: true,
                                                                    suggestion_pos: {top: rect.bottom, left: rect.left, width: rect.width},
                                                                });
                                                            }}
                                                            onFocus={e => {
                                                                const rect = e.target.getBoundingClientRect();
                                                                this.updateLineItem(idx, {
                                                                    show_suggestions: true,
                                                                    suggestion_pos: {top: rect.bottom, left: rect.left, width: rect.width},
                                                                });
                                                            }}
                                                            onBlur={() => setTimeout(() => this.updateLineItem(idx, {show_suggestions: false}), 200)}
                                                        />
                                                        {item.loading_items && (
                                                            <div className="small text-muted mt-1">
                                                                <i className="fas fa-spinner fa-spin mr-1"></i>Loading items...
                                                            </div>
                                                        )}
                                                        {item.show_suggestions && suggestions.length > 0 && item.suggestion_pos && (
                                                            <div style={{
                                                                position: "fixed",
                                                                top: item.suggestion_pos.top,
                                                                left: item.suggestion_pos.left,
                                                                width: item.suggestion_pos.width,
                                                                zIndex: 9999,
                                                                background: "#fff",
                                                                border: "1px solid #ced4da",
                                                                borderRadius: "0 0 4px 4px",
                                                                maxHeight: "200px",
                                                                overflowY: "auto",
                                                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                                                            }}>
                                                                {suggestions.map((s, si) => (
                                                                    <div
                                                                        key={si}
                                                                        className="px-2 py-1"
                                                                        style={{cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontSize: "12px"}}
                                                                        onMouseDown={() => this.selectSuggestion(idx, s)}
                                                                    >
                                                                        <strong>{s.item}</strong>&nbsp;&mdash;&nbsp;{s.name}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {item.item_locked && (
                                                        <Button size="sm" color="link" className="p-0 pl-1 text-danger" onClick={() => this.clearItemLock(idx)}
                                                                title="Clear pre-filled item">
                                                            <i className="fas fa-times-circle"></i>
                                                        </Button>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <Input type="text" bsSize="sm" value={item.name} disabled={item.item_locked}
                                                       onChange={e => this.updateLineItem(idx, {name: e.target.value})}/>
                                            </td>
                                            <td>
                                                <Input type="text" bsSize="sm" value={item.item_description} disabled={item.item_locked}
                                                       onChange={e => this.updateLineItem(idx, {item_description: e.target.value})}/>
                                            </td>
                                            <td>
                                                <InputGroup size="sm">
                                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                                    <Input type="number" value={item.rate} disabled={item.item_locked}
                                                           onChange={e => this.updateLineItem(idx, {rate: e.target.value})} style={{textAlign: "right"}}/>
                                                </InputGroup>
                                            </td>
                                            <td>
                                                <Input type="number" bsSize="sm" value={item.quantity} min="0" onChange={e => this.updateLineItem(idx, {quantity: e.target.value})}
                                                       style={{textAlign: "right"}}/>
                                            </td>
                                            <td>
                                                <InputGroup size="sm">
                                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                                    <Input type="number" value={item.amount} readOnly style={{textAlign: "right", background: "#f8f9fa"}}/>
                                                </InputGroup>
                                            </td>
                                            <td className="text-center">
                                                <Button size="sm" color="danger" outline onClick={() => this.removeLineItem(idx)} title="Remove row">
                                                    <i className="fas fa-trash-alt"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                            <Button color="secondary" size="sm" onClick={this.addLineItem} disabled={!headerComplete}>
                            <i className="fas fa-plus mr-1"></i> Add New Item
                        </Button>
                        </div>
                    </CardBody>
                </Card>
            </ContentWrapper>
        );
    }
}

export default CreateMaintenanceTicket;
